const PATHS = {};

PATHS.LOGIN = "/login";
PATHS.HOME = "/user/home";
PATHS.EXTERNAL_CONFIRM_LOGIN = "/authConfirm/:token";
PATHS.EVALUATION = "/user/evaluation/toEval";
PATHS.NEW_EVALUATION = "/user/evaluation/new/:year/:userUuid";
PATHS.EDIT_EVALUATION = "/user/evaluation/edit/:uuid";
PATHS.VIEW_EVALUATION = "/user/evaluation/view/:uuid";
PATHS.LIST_EVALUATION = "/user/evaluation/myTeam/list";
PATHS.RH_LIST_EVALUATION = "/user/evaluation/list";
PATHS.CONFIG = "/user/configuration";
PATHS.CALIBRATION = "/user/upload/calibration";

PATHS.EVALUATION_EVAL_MANAGER = "/user/evaluation/eval/manager/:uuid";

PATHS.EVALUATION_ORG_CHART = "/user/evaluation/organigrama";

PATHS.NEW_REPORT = "/user/report/new";
PATHS.EDIT_REPORT = "/user/report/edit/:uuid";
PATHS.VIEW_REPORT = "/user/report/view/:uuid";
PATHS.REPORT_RES_FINAL = "/user/report/resFinal";


export default PATHS;
